import React, { useState, useEffect, forwardRef, useImperativeHandle } from 'react';
import { Segment } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import Table from './Table';

import styles from './table.module.scss';

const DataTable = forwardRef((props, ref) => {
  const {
    data,
    columns,
    currentPage = 1,
    paginated,
    limit,
    totalCount,
    onParamsChanges,
    loading,
    handleRowClick,
    striped,
    rowSpacing,
  } = props;

  const [sort, setSort] = useState();
  const [order, setOrder] = useState(null);

  const [page, setPage] = useState(currentPage);
  const [limitSize, setLimitSize] = useState(limit);

  const changeParams = () => {
    if (typeof onParamsChanges === 'function') {
      const requestParams = {};
      if (sort) {
        requestParams.order = order;
        requestParams.sortBy = sort;
      }
      if (paginated) {
        requestParams.page = page;
        requestParams.limit = limitSize;
      }
      onParamsChanges(requestParams);
    }
  };

  useImperativeHandle(ref, () => ({
    loadCurrentData() {
      changeParams();
    },
  }));

  const handleSort = (clickedColumn) => {
    let newOrder = order === 'asc' ? 'desc' : 'asc';

    if (sort !== clickedColumn) {
      newOrder = 'asc';
    }
    setSort(clickedColumn);
    setOrder(newOrder);
  };

  const onChangeLimit = (event, eventData) => {
    setLimitSize(eventData.value);
    setPage(1);
  };

  const onPageChange = (event, eventData) => setPage(eventData.activePage);

  useEffect(() => {
    changeParams();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [order, sort, page, limitSize, paginated, onParamsChanges]);

  return (
    <Segment id={styles.dataTableContainer}>
      <Table
        isLoading={loading}
        columns={columns}
        data={data}
        totalCount={totalCount}
        totalPages={Math.ceil(totalCount / limitSize)}
        currentPage={page}
        onPageChange={onPageChange}
        column={sort}
        direction={order}
        handleSort={handleSort}
        onChangeLimit={onChangeLimit}
        limit={+limitSize}
        handleRowClick={handleRowClick}
        striped={striped}
        rowSpacing={rowSpacing}
      />
    </Segment>
  );
});

DataTable.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.shape({})),
  data: PropTypes.arrayOf(PropTypes.shape({})),
  currentPage: PropTypes.number,
  paginated: PropTypes.bool,
  limit: PropTypes.number,
  totalCount: PropTypes.number,
  onParamsChanges: PropTypes.func,
  loading: PropTypes.bool,
  handleRowClick: PropTypes.func,
  striped: PropTypes.bool,
  rowSpacing: PropTypes.number,
};

DataTable.defaultProps = {
  columns: [],
  data: [],
  currentPage: 1,
  paginated: true,
  limit: 10,
  totalCount: 0,
  onParamsChanges: () => { },
  loading: false,
  handleRowClick: null,
  striped: true,
  rowSpacing: 0,
};

export default DataTable;
